export const splitArrayIntoSubArrays = <T>(
  input: T[] = [],
  pageSize = 4,
): T[][] => {
  const pages = [];
  for (let i = 0; i < input.length; i += pageSize) {
    pages.push(input.slice(i, i + pageSize));
  }
  return pages;
};

export const splitArrayIntoNSubArrays = <T>(input: T[], n: number): T[][] => {
  if (n <= 0) {
    return [input];
  }
  const pages = Math.ceil(input.length / n);
  return splitArrayIntoSubArrays(input, pages);
};

export const chunkArray = <T>(array: T[], chunkSize: number): T[][] => {
  const result: T[][] = [];
  for (let i = 0; i < array.length; i += chunkSize) {
    result.push(array.slice(i, i + chunkSize));
  }
  return result;
};
